import React from 'react';
import { SVGS } from '../../../assets/svgs';

const getNonEmpty = (value: unknown, fallback = '-') => {
  if (value === null || value === undefined) return fallback;
  const text = String(value).trim();
  return text.length ? text : fallback;
};

const avatarThemes = [
  'company-details-screen__avatar--lavender',
  'company-details-screen__avatar--sky',
  'company-details-screen__avatar--sage',
  'company-details-screen__avatar--peach',
];

export const CfaTabContent: React.FC<{ cfaRows: any[] }> = ({ cfaRows }) => (
  <div className="company-details-screen__tab-content">
    <div className="company-details-screen__section">
      <div className="company-details-screen__section-title font-semibold">
        CFA / Divisions ({cfaRows?.length || 0})
      </div>
      <div className="company-details-screen__cfa-card">
        {cfaRows.length ? (
          cfaRows.map((cfa: any, idx: number) => (
            <div
              className="company-details-screen__card"
              key={cfa?.id ?? `${cfa?.name}-${idx}`}
            >
              <div className="company-details-screen__cfa-row">
                <div className="company-details-screen__cfa-header">
                  {/* <img
                  src={SVGS.Location}
                  className="company-details-screen__row-icon"
                /> */}
                  <div
                    className={`company-details-screen__avatar ${
                      avatarThemes[idx % avatarThemes.length]
                    }`}
                  >
                    <img src={SVGS.Location} alt="location" />
                  </div>
                  <div>
                    <div className="company-details-screen__value font-semibold">
                      {getNonEmpty(cfa?.name)}
                    </div>
                    <div className="company-details-screen__label font-regular">
                      {getNonEmpty(cfa?.mobile)} • {cfa?.divisions?.length || 0}{' '}
                      Divisions
                    </div>
                  </div>
                </div>
                <div className="company-details-screen__chip-wrap">
                  {(cfa?.divisions ?? []).length ? (
                    cfa.divisions.map((division: any) => (
                      <span
                        className="company-details-screen__chip font-regular"
                        key={division?.id}
                      >
                        {getNonEmpty(division?.name)}
                      </span>
                    ))
                  ) : (
                    <span className="company-details-screen__empty font-regular">
                      No divisions mapped
                    </span>
                  )}
                </div>
                {/* {idx !== cfaRows.length - 1 && (
                  <div className="company-details-screen__divider" />
                )} */}
              </div>
            </div>
          ))
        ) : (
          <div className="company-details-screen__empty font-regular">
            No CFA data found.
          </div>
        )}
      </div>
    </div>
  </div>
);
